<template>
  <v-container
    fluid
    id="loginContainer"
    class="primary fill-height d-flex justify-center"
    :style="{
      minHeight: '580px',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '678px 561px',
      position: 'relative',
      overflow: 'hidden',
    }"
  >
    <!-- background: 'url(' + logobg + ')', -->
    <!-- webPc 的页面 -->
    <div class="webPc" v-if="webPc" style="z-index: 20">
      <!-- 发送邮件 -->
      <v-card class="webSendMail" elevation="24" v-if="sendMail">
        <div class="forgot_title text-h3">
          {{ $t("label_Retrieve_password") }}
        </div>
        <v-form ref="form">
          <v-text-field
            :label="$t('label_Company_account')"
            :placeholder="$t('label_Company_account')"
            background-color="#fff"
            :rules="$GetRules(['_Require_Rules'], [null])"
            style="margin-top: 40px"
            @keyupEnter="sendEmailHandler"
            v-model.trim="sendEmailParams.user_account"
          >
          </v-text-field>
        </v-form>

        <CardActions
          submitBtn
          :animated="false"
          class="mt-7"
          style="height: 48px; justify-content: flex-end !important"
          @cancel="backHandler"
          @submit="sendEmailHandler"
        />
      </v-card>
    </div>

    <!-- 这是手机的输入框 -->
    <div class="phoneH5" v-else>
      <v-card v-if="sendMail" class="sendMail">
        <div class="forgot_title text-h3">
          {{ $t("label_Retrieve_password") }}
        </div>
        <v-form ref="form">
          <v-text-field
            :label="$t('label_Company_account')"
            background-color="#fff"
            :rules="$GetRules(['_Require_Rules'], [null])"
            class="mt-10"
            @keyupEnter="sendEmailHandler"
            v-model.trim="sendEmailParams.user_account"
          >
          </v-text-field>
        </v-form>
        <CardActions
          submitBtn
          style="height: 48px; justify-content: flex-end !important"
          @cancel="backHandler"
          @submit="sendEmailHandler"
        />
      </v-card>
    </div>
    <svg-icon
      :size="bgstyle"
      iconClass="left"
      class="left_bg"
      :style="{
        left: -bgstyle / 2 + 'px',
      }"
    />
    <svg-icon
      :size="bgstyle"
      iconClass="right"
      class="right_bg"
      :style="{
        right: -bgstyle / 2 + 'px',
      }"
    />

    <v-sheet class="text-center footer-container max-width transparent">
      <Footer
        fontColor="rgba(255, 255, 255, 0.68)"
        contentClass="pa-0 ma-0 pt-4"
        linkReverse
        center
      />
    </v-sheet>
  </v-container>
</template>
<script>
import Footer from "@/Layout/components/Footer";
import logobg from "@/assets/BG_Blue.png";
import { mapGetters } from "vuex";
export default {
  name: "Login",
  components: { Footer },
  computed: {
    ...mapGetters(["loginEncryptKey"]),
    bgstyle() {
      let size = 0;
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          size = 0;
          break;
        case "sm":
          size = 600;
          break;
        case "md":
          size = 900;

          break;
        case "lg":
          size = 1000;

        case "xl":
          size = 1200;

          break;
        default:
          break;
      }
      return size;
    },
  },
  data() {
    return {
      logobg: logobg,
      login_url: "",
      sendMail: false,
      sendEmailParams: {
        user_account: "",
      },
      screenSize: "", // 是web的尺寸 true  手机的尺寸 false
      webPc: true,
      loading: false,
      email: "",
    };
  },
  async created() {
    await this.$store.dispatch("getLoginEncryptKey");
    this.login_url = this.$aesDecrypt(this.$route.params.login_url);
    this.sendMail = true;
    const that = this;
    that.screenSize = document.documentElement.clientWidth;
    if (that.screenSize > 750) {
      that.webPc = true;
    } else {
      that.webPc = false;
    }
    this.resize(function () {
      that.screenSize = document.documentElement.clientWidth;
      if (that.screenSize > 750) {
        that.webPc = true;
      } else {
        that.webPc = false;
      }
    });
  },
  methods: {
    // 发送邮件
    async sendEmailHandler() {
      if (!this.$refs["form"].validate()) return;
      this.loading = true;
      const login_url = encodeURIComponent(this.login_url)
        ? encodeURIComponent(this.login_url)
        : "";
      this.$Request({
        method: "POST",
        table: "mrbase_sys_users",
        url: "/personalcenter/send-updatePwdEmail/",
        data: {
          user_account: this.$loginEncrypt({
            msg: this.sendEmailParams.user_account,
            key: this.loginEncryptKey,
          }),
          login_url: login_url,
          url: window.location.host,
        },
        type: "lang",
      }).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.email = res.data;
          this.$confirmWarn(
            this.$t("label_pleaseCheckMailBox"),
            this.$t("label_forgotPasswordSendMailboxTips") + res.data,
            null,
            null,
            true,
            false
          )
            .then((res) => {
              this.$toPage("/login", {}, "replace");
            })
            .catch((err) => {
              this.sendEmailHandler();
            });
        }
      });
    },
    // back
    backHandler() {
      this.$toPage("/login", {}, "replace");
    },
    resize(fn) {
      window.addEventListener("resize", function () {
        fn();
      });
    },
  },
};
</script>
<style scoped>
.logo_module {
  width: 480px;
  height: 480px;
  padding: 0px 48px;
  position: absolute;
  top: 50%;
  z-index: 20;
  left: 50%;
  transform: translate(-50%, -50%);
}

@media screen and (max-width: 375px) {
  .logo_module {
    /* width: 341px; */
    width: 343px;
  }
  .lang_name {
    width: 64px;
  }
  .btn {
    width: 80px !important;
  }
  .btntext {
    max-width: 24px !important;
  }
}
.footer-container {
  position: absolute;
  z-index: 0;
  bottom: 0;
}

.forget-password {
  width: 100%;
  height: 100%;
  position: relative;
  background: url("../../../assets/BG_Blue.png") no-repeat;
  text-align: center;
  background-color: #0f46c1;
}
.webResetPassword,
.webSendMail {
  width: 480px;
  height: 265px;
  border-radius: 4px;
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 0 32px;
}

.webSendMail {
  height: 265px;
}

.webPc .forgot_title {
  margin-top: 32px;
  text-align: left;
  font-size: 28px;
}

.forget-password /deep/ .btnGroup {
  justify-content: flex-end;
  height: 48px;
}
.forget-password /deep/ .successBtn {
  width: 170px;
  height: 48px;
  max-height: 48px !important;
  margin-left: 14px;
}
.forget-password /deep/ .cencelBtn {
  font-weight: medium;
  margin-right: 0;
}

.phoneH5 .sendMail,
.phoneH5 .resetPassword {
  height: 240px;
  border-radius: 4px;
  background: #ffffff;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  padding: 0 32px;
  width: 343px;
}
.phoneH5 .sendMail,
.phoneH5 .resetPassword {
  min-width: 300px;
}
.phoneH5 .resetPassword {
  height: 500px;
}
.phoneH5 .forgot_title {
  margin-top: 32px;
  text-align: left;
  font-size: 28px;
}
.phoneH5 .phoneSubmitBtn /deep/ .successBtn {
  margin: 20px 0;
}

.bottom {
  width: 100%;
  position: absolute;
  bottom: 5px;
  text-align: center;
  left: 50%;
  z-index: 10;
  color: rgba(255, 255, 255, 0.68);
  transform: translateX(-50%);
  font-family: var(--body-font-family) !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 12px !important;
  line-height: 128.91% !important;
}
.bottom p {
  letter-spacing: 1px;
  margin: 0;
}
.v-application .grey.lighten-2 {
  background-color: #ffffff !important;
}
.left_bg {
  position: absolute;
  bottom: 0;
  z-index: 0;
  -webkit-animation: rotate 20s ease-in-out infinite;
  -moz-animation: rotate 20s ease-in-out infinite;
  -o-animation: rotate 20s ease-in-out infinite;
  animation: rotate 20s ease-in-out infinite;
}
.right_bg {
  position: absolute;
  z-index: 0;
  top: 0;
  -webkit-animation: rotate 20s ease-in-out infinite;
  -moz-animation: rotate 20s ease-in-out infinite;
  -o-animation: rotate 20s ease-in-out infinite;
  animation: rotate 20s ease-in-out infinite;
}
/* 旋转 */
@-webkit-keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
  }
  50% {
    -webkit-transform: rotate(180deg) scale(1.5);
    transform: rotate(180deg) scale(1.5);
  }
  100% {
    -webkit-transform: rotate(360deg) scale(1);
    transform: rotate(360deg) scale(1);
  }
}
@-moz-keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
  }
  50% {
    -webkit-transform: rotate(180deg) scale(1.5);
    transform: rotate(180deg) scale(1.5);
  }
  100% {
    -webkit-transform: rotate(359deg) scale(1);
    transform: rotate(359deg) scale(1);
  }
}
@-o-keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
  }
  50% {
    -webkit-transform: rotate(180deg) scale(1.5);
    transform: rotate(180deg) scale(1.5);
  }
  100% {
    -webkit-transform: rotate(359deg) scale(1);
    transform: rotate(359deg) scale(1);
  }
}
@keyframes rotate {
  0% {
    -webkit-transform: rotate(0deg) scale(1);
    transform: rotate(0deg) scale(1);
  }
  50% {
    -webkit-transform: rotate(180deg) scale(1.5);
    transform: rotate(180deg) scale(1.5);
  }
  100% {
    -webkit-transform: rotate(359deg) scale(1);
    transform: rotate(359deg) scale(1);
  }
}
</style>
